import { createMockProduct, createProductsAndExchangeToProductsFn, createReturnReasonConfigAlga } from "../mockCore";
import { SHIPMENT_SOLUTION_TYPES } from "~/cores/shipment.core";

const productData1 = {
    product: createMockProduct({
        id: 1,
        productName: "The Body Wash",
        imageSrc: "/mocks/Body-wash.jpg",
        purchasePrice: 25,
        returnReasonConfig: createReturnReasonConfigAlga(),
        properties: [
            {
                type: "Size",
                value: "120 ml/4.0 fl.oz",
            },
        ],
    }),
    similarProducts: [
        {
            actualProductId: 11,
            productName: "The Body Butter",
            imageSrc: "/mocks/The-body-butter.jpg",
            purchasePrice: 30,
            currency: "DEFAULT",
            properties: [
                {
                    type: "Size",
                    value: "60 ml/2.0 fl.oz",
                },
            ],
            variants: [
                {
                    id: 42,
                    productName: "The Body Butter",
                    hasInventory: true,
                    properties: [
                        {
                            type: "Size",
                            value: "60 ml/2.0 fl.oz",
                        },
                    ],
                    productVariantTypeValues: ["60 ml/2.0 fl.oz"],
                },
            ],
        },
        {
            actualProductId: 12,
            productName: "The Face Serum",
            imageSrc: "/mocks/The-face-serum.jpg",
            purchasePrice: 19,
            currency: "DEFAULT",
            properties: [
                {
                    type: "Size",
                    value: "60 ml/2.0 fl.oz",
                },
            ],
            variants: [
                {
                    id: 422,
                    productName: "The Face Serum",
                    hasInventory: true,
                    properties: [
                        {
                            type: "Size",
                            value: "60 ml/2.0 fl.oz",
                        },
                    ],
                    productVariantTypeValues: ["60 ml/2.0 fl.oz"],
                },
            ],
        },
        {
            actualProductId: 13,
            productName: "The Hair Spray",
            imageSrc: "/mocks/Hair-spray.jpg",
            purchasePrice: 29,
            currency: "DEFAULT",
            properties: [
                {
                    type: "Size",
                    value: "60 ml/2.0 fl.oz",
                },
            ],
            variants: [
                {
                    id: 2242,
                    productName: "The Hair Spray",
                    hasInventory: true,
                    properties: [
                        {
                            type: "Size",
                            value: "60 ml/2.0 fl.oz",
                        },
                    ],
                    productVariantTypeValues: ["60 ml/2.0 fl.oz"],
                },
            ],
        },
    ],
};

const productData2 = {
    product: createMockProduct({
        id: 2,
        productName: "The Body Butter",
        imageSrc: "/mocks/The-body-butter.jpg",
        purchasePrice: 30,
        returnReasonConfig: createReturnReasonConfigAlga(),
        properties: [
            {
                type: "Size",
                value: "60 ml/2.0 fl.oz",
            },
        ],
    }),
    similarProducts: [
        {
            actualProductId: 15,
            productName: "The Body Wash",
            imageSrc: "/mocks/Body-wash.jpg",
            currency: "DEFAULT",
            purchasePrice: 25,
            properties: [
                {
                    type: "Size",
                    value: "120 ml/4.0 fl.oz",
                },
            ],
            variants: [
                {
                    id: 4223,
                    productName: "The Body Wash",
                    hasInventory: true,
                    properties: [
                        {
                            type: "Size",
                            value: "120 ml/4.0 fl.oz",
                        },
                    ],
                    productVariantTypeValues: ["120 ml/4.0 fl.oz"],
                },
            ],
        },
        {
            actualProductId: 16,
            productName: "The Face Serum",
            imageSrc: "/mocks/The-face-serum.jpg",
            purchasePrice: 19,
            currency: "DEFAULT",
            properties: [
                {
                    type: "Size",
                    value: "60 ml/2.0 fl.oz",
                },
            ],
            variants: [
                {
                    id: 132,
                    productName: "The Face Serum",
                    hasInventory: true,
                    properties: [
                        {
                            type: "Size",
                            value: "60 ml/2.0 fl.oz",
                        },
                    ],
                    productVariantTypeValues: ["60 ml/2.0 fl.oz"],
                },
            ],
        },
        {
            actualProductId: 17,
            productName: "The Hair Spray",
            imageSrc: "/mocks/Hair-spray.jpg",
            purchasePrice: 29,
            currency: "DEFAULT",
            properties: [
                {
                    type: "Size",
                    value: "60 ml/2.0 fl.oz",
                },
            ],
            variants: [
                {
                    id: 4442,
                    productName: "The Hair Spray",
                    hasInventory: true,
                    properties: [
                        {
                            type: "Size",
                            value: "60 ml/2.0 fl.oz",
                        },
                    ],
                    productVariantTypeValues: ["60 ml/2.0 fl.oz"],
                },
            ],
        },
    ],
};

const productData3 = {
    product: createMockProduct({
        id: 3,
        productName: "The Hair Spray",
        imageSrc: "/mocks/Hair-spray.jpg",
        purchasePrice: 29,
        returnReasonConfig: createReturnReasonConfigAlga(),
        properties: [
            {
                type: "Size",
                value: "60 ml/2.0 fl.oz",
            },
        ],
    }),
    similarProducts: [
        {
            actualProductId: 15,
            productName: "The Body Wash",
            imageSrc: "/mocks/Body-wash.jpg",
            currency: "DEFAULT",
            purchasePrice: 25,
            properties: [
                {
                    type: "Size",
                    value: "120 ml/4.0 fl.oz",
                },
            ],
            variants: [
                {
                    id: 492,
                    productName: "The Body Wash",
                    hasInventory: true,
                    properties: [
                        {
                            type: "Size",
                            value: "120 ml/4.0 fl.oz",
                        },
                    ],
                    productVariantTypeValues: ["120 ml/4.0 fl.oz"],
                },
            ],
        },
        {
            actualProductId: 16,
            productName: "The Face Serum",
            imageSrc: "/mocks/The-face-serum.jpg",
            purchasePrice: 19,
            currency: "DEFAULT",
            properties: [
                {
                    type: "Size",
                    value: "60 ml/2.0 fl.oz",
                },
            ],
            variants: [
                {
                    id: 472,
                    productName: "The Face Serum",
                    hasInventory: true,
                    properties: [
                        {
                            type: "Size",
                            value: "60 ml/2.0 fl.oz",
                        },
                    ],
                    productVariantTypeValues: ["60 ml/2.0 fl.oz"],
                },
            ],
        },
        {
            actualProductId: 17,
            productName: "The Body Butter",
            imageSrc: "/mocks/The-body-butter.jpg",
            purchasePrice: 30,
            currency: "DEFAULT",
            properties: [
                {
                    type: "Size",
                    value: "60 ml/2.0 fl.oz",
                },
            ],
            variants: [
                {
                    id: 482,
                    productName: "The Body Butter",
                    hasInventory: true,
                    properties: [
                        {
                            type: "Size",
                            value: "60 ml/2.0 fl.oz",
                        },
                    ],
                    productVariantTypeValues: ["60 ml/2.0 fl.oz"],
                },
            ],
        },
    ],
};

const productsAndExchangeToProductsFn = createProductsAndExchangeToProductsFn([productData1, productData2, productData3]);

export function getExchangeToProducts({ productId }) {
    return productsAndExchangeToProductsFn.exchangeToProductsFn({ productId });
}

export function getProducts() {
    return {
        sessionId: "170bfc7b-8910-43a7-8903-52c9894ed015",
        pickupDateSelectionAllowed: true,
        shipmentSolutions: [
            {
                carrier: "POST_NL",
                type: SHIPMENT_SOLUTION_TYPES.PRINT_LABEL.key,
                cost: 0,
            },
            {
                carrier: "UPS",
                type: SHIPMENT_SOLUTION_TYPES.PRINT_LABEL.key,
                cost: 3.9,
            },
            {
                carrier: "IN_STORE",
                type: SHIPMENT_SOLUTION_TYPES.RETURN_IN_STORE.key,
                cost: 0,
            },
        ],
        paidShipping: 4.0,
        turnrShippingCost: 5.9,
        returnHandlingCost: -7.9,
        currencyCode: "EUR",
        refundOptions: [
            {
                type: "BASIC",
            },
            {
                type: "GIFT_CARD",
                bonusPercentage: 0.2,
            },
        ],
        products: productsAndExchangeToProductsFn.products,
    };
}

export function getSimilarProducts({ productId }) {
    return productsAndExchangeToProductsFn.similarProductsFn({ productId });
}
